// extracted by mini-css-extract-plugin
export default {"sortable-item":"SortableItem_sortable-item__Mmu6i","topIndex":"SortableItem_topIndex__wFarO"};